import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as networkSelectors from 'app/state/network/network-selectors';
import { LicenseReportSummaries, PaymentPeriodSummaries, PaymentPeriodSummary, TaxSummaryHeader } from './styles';
import styled from "styled-components";
import { LicenseReportSummary } from "./license-report-summary";
import { TotalPaymentLineItem } from "./license-report-summary/line-item";

const MultiPropertyPaymentPeriodLabel = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
`;

// See "TaxSummary" of "tax-summary.ts" and "createTaxSummary" of "create-tax-summary.ts"
export function TaxSummary(props) {
  const { providers, lineItems } = props;

  const paymentFees = useSelector(networkSelectors.paymentFees);

  const {
    providerLineItems,
    providerOrder,
  } = useMemo(() => ({
    providerLineItems: providers.map(({ label }) => label),
    providerOrder: providers.map(({ provider }) => provider),
  }), [providers]);

  return (
    <div>
      <TaxSummaryHeader>Tax Summary</TaxSummaryHeader>

      <PaymentPeriodSummaries>
        {paymentFees.paymentPeriods.map((period) => (
          <PaymentPeriodSummary key={period.period}>
            {period.licenseReports.length > 1 && (
              <MultiPropertyPaymentPeriodLabel>
                {period.period}
              </MultiPropertyPaymentPeriodLabel>
            )}

            <LicenseReportSummaries>
              {period.licenseReports.map((licenseReport) => {
                return (
                  <LicenseReportSummary
                    key={licenseReport.licenseId}
                    licenseReport={licenseReport}
                    period={period}
                    providerLineItems={providerLineItems}
                    providerOrder={providerOrder}
                    lineItems={lineItems}
                    hidePeriodName={period.licenseReports.length > 1}
                    hidePropertyLabel={period.licenseReports.length < 2}
                  />
                )
              })}
            </LicenseReportSummaries>
          </PaymentPeriodSummary>
        ))}
      </PaymentPeriodSummaries>

      <TotalPaymentLineItem items={[paymentFees.summary.total]} />
    </div>
  );
}
